var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "auth-token-manager"
  }, [(_vm.isAuthenticatedAsAdmin) ? [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "end",
      "gap": "1rem"
    }
  }, [_c('select-input', {
    staticStyle: {
      "margin-bottom": "0",
      "margin-top": "0 !important"
    },
    attrs: {
      "include-blank": false,
      "collection": _vm.ttlOptions,
      "label": 'Dauer'
    },
    model: {
      value: (_vm.tempTokenTtl),
      callback: function($$v) {
        _vm.tempTokenTtl = $$v
      },
      expression: "tempTokenTtl"
    }
  }), _vm._v(" "), _c('text-input', {
    staticStyle: {
      "margin-bottom": "0"
    },
    attrs: {
      "label": _vm.$t('fields.comment') + '*'
    },
    model: {
      value: (_vm.tokencomment),
      callback: function($$v) {
        _vm.tokencomment = $$v
      },
      expression: "tokencomment"
    }
  }), _vm._v(" "), _c('common-button', {
    attrs: {
      "disabled": !_vm.hasTokencomment,
      "icon": "plus"
    },
    on: {
      "click": _vm.issueTempToken
    }
  }, [_vm._v(_vm._s(_vm.$t('buttons.issueToken')))]), _vm._v(" "), _c('revoke-all-tokens-button', {
    staticStyle: {
      "margin-left": "auto"
    },
    attrs: {
      "subject": _vm.resource
    },
    on: {
      "done": _vm.clearAuthTokens
    }
  })], 1)] : _vm._e(), _vm._v(" "), _c('data-grid', {
    staticClass: "uk-margin-medium",
    attrs: {
      "columns": _vm.gridColumns,
      "rows": _vm.gridRows
    },
    scopedSlots: _vm._u([{
      key: "row",
      fn: function(props) {
        return [_c('td', [_c('time-to-go', {
          attrs: {
            "datetime": props.row.expiresAt
          }
        })], 1), _vm._v(" "), _c('td', [(props.row.comment) ? _c('span', [_vm._v("\n          " + _vm._s(props.row.comment) + "\n        ")]) : _c('span', {
          staticStyle: {
            "color": "red"
          }
        }, [_vm._v("\n          Keiner angegeben\n        ")])]), _vm._v(" "), _c('td', [_c('timeago', {
          attrs: {
            "auto-update": 60,
            "since": props.row.issuedAt
          }
        })], 1), _vm._v(" "), _c('td', [_c('code', [_c('a', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard",
            value: (props.row.token),
            expression: "props.row.token"
          }],
          attrs: {
            "title": _vm.$t('actions.copyToken', {
              token: props.row.token
            }),
            "href": "#"
          },
          on: {
            "error": _vm.copyError,
            "success": _vm.copySuccess
          }
        }, [_vm._v(_vm._s(_vm.shortenToken(props.row.token)))])])]), _vm._v(" "), _c('td', [_c('data-grid-actions', {
          attrs: {
            "editable": false,
            "removable": _vm.isAuthenticatedAsAdmin
          },
          on: {
            "remove": function($event) {
              _vm.revokeTokenWhenConfirmed(props.row)
            }
          }
        }, [_vm._t("before", [_c('li', [_c('a', {
          directives: [{
            name: "clipboard",
            rawName: "v-clipboard",
            value: (props.row.token),
            expression: "props.row.token"
          }],
          attrs: {
            "href": "#"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
            },
            "error": _vm.copyError,
            "success": _vm.copySuccess
          }
        }, [_c('icon', {
          attrs: {
            "name": "copy"
          }
        })], 1)])])], 2)], 1)]
      }
    }])
  }, [_c('span', {
    slot: "empty"
  }, [_vm._v(_vm._s(_vm.$t('hints.empty')))])])], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a57df92","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/AuthTokenManager.vue
// module id = 2002
// module chunks = 0